import i18next from "i18next";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { createProxy, getPath, type ObjPathProxy } from "ts-object-path";
import type { MyPlannResourceDictionary } from "web_myplann/Infrastructure/Translations/ResourceDictionary";

export const Resources = createProxy<MyPlannResourceDictionary>();

export function getResourcePath<T>(proxy: ObjPathProxy<T, string>): string {
	const path = getPath(proxy);

	if (!path || path.length === 0) return "";
	if (path.length === 1) return path[0].toString();
	return `${path[0].toString()}.${path.slice(1).join(".")}`;
}

export function useResource() {
	const { t: i18Translation } = useTranslation();

	const t = useCallback(
		(
			resourcePath: ObjPathProxy<MyPlannResourceDictionary, string>,
			options?: unknown,
		) =>
			i18Translation(
				getResourcePath(resourcePath),
				options as Record<string, unknown>,
			) as unknown as string,
		[i18Translation],
	);

	return { t };
}

export function getTranslation(
	resourcePath: ObjPathProxy<MyPlannResourceDictionary, string>,
) {
	return i18next.t(getResourcePath(resourcePath));
}
